function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 10.703l80 5.3c80 5.7 240 15.7 400 10.7s320-27 480-26.7c160-.3 320 21.7 400 32l80 10.7-80-.003H0V10.703z",
  fill: "#FFF5F1",
  fillRule: "evenodd"
});

function SvgLogosTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 43"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDQwIDQzIj48cGF0aCBkPSJNMCAxMC43MDNsODAgNS4zYzgwIDUuNyAyNDAgMTUuNyA0MDAgMTAuN3MzMjAtMjcgNDgwLTI2LjdjMTYwLS4zIDMyMCAyMS43IDQwMCAzMmw4MCAxMC43LTgwLS4wMDNIMFYxMC43MDN6IiBmaWxsPSIjRkZGNUYxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export { SvgLogosTop as ReactComponent };